/* ELAXO · pulsanti del carrello (08-10-2026).
   «Passa al Rituale» e «È un regalo» con ascolto sull'intera pagina: funzionano anche quando
   il tema ridisegna il cassetto del carrello dopo un'aggiunta (gli script dentro il cassetto
   in quel caso non partono: era il motivo per cui i due pulsanti a volte non facevano nulla). */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  function render(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.renderContents && state && state.sections && state.sections['cart-drawer'] && !document.getElementById('main-cart-items')) {
      drawer.renderContents(state);
    } else {
      window.location.reload();
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-elx-switch]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var updates = {};
    (b.dataset.keys || '').split(',').filter(Boolean).forEach(function (k) { updates[k] = 0; });
    b.disabled = true; b.textContent = b.dataset.busy || '…';
    fetch(root + 'cart/update.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ updates: updates }) })
      .then(function () {
        return fetch(root + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({
          items: [{ id: Number(b.dataset.variant), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) });
      })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { window.location.reload(); });
  });
  var timer;
  function saveGift(w) {
    var cb = w.querySelector('input[type="checkbox"]'), ta = w.querySelector('textarea'), ok = w.querySelector('.elx-gift__ok');
    var on = cb && cb.checked;
    fetch(root + 'cart/update.js', { method: 'POST', headers: JSONH,
      body: JSON.stringify({ attributes: { 'Regalo': on ? 'Sì' : '', 'Biglietto': on && ta ? ta.value.slice(0, 200) : '' } }) })
      .then(function () { if (ok) { ok.hidden = false; setTimeout(function () { ok.hidden = true; }, 1500); } });
  }
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-elx-gift] input[type="checkbox"]');
    if (!cb) return;
    var w = cb.closest('[data-elx-gift]'), body = w.querySelector('.elx-gift__body');
    if (body) body.hidden = !cb.checked;
    saveGift(w);
  });
  document.addEventListener('input', function (e) {
    var ta = e.target.closest('[data-elx-gift] textarea');
    if (!ta) return;
    clearTimeout(timer);
    var w = ta.closest('[data-elx-gift]');
    timer = setTimeout(function () { saveGift(w); }, 600);
  });

  // Stelle sotto il nome (badge Judge.me): portano all'inizio delle recensioni ELAXO,
  // non a metà pagina verso il blocco nascosto dell'app.
  document.addEventListener('click', function (e) {
    var badge = e.target.closest('.jdgm-prev-badge');
    var target = document.getElementById('recensioni');
    if (!badge || !target) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var smooth = window.matchMedia && matchMedia('(prefers-reduced-motion: no-preference)').matches;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }, true);

  // Etichetta «Made in Italy · Testato su pelle sensibile» sulla prima foto della scheda (telefono).
  // Testo tradotto qui sotto (dal CSS il «·» arrivava codificato male).
  (function () {
    if (!document.body.classList.contains('template-product') || document.documentElement.classList.contains('elx-v3')) return;
    var media = document.querySelector('.product__media-list .swiper-slide .product__media');
    if (!media || media.querySelector('.elx-ovl')) return;
    var L = { it: 'Made in Italy · Testato su pelle sensibile', en: 'Made in Italy · Tested on sensitive skin',
      de: 'Made in Italy · An empfindlicher Haut getestet', fr: 'Made in Italy · Testé sur peau sensible',
      es: 'Made in Italy · Probado en piel sensible', nl: 'Made in Italy · Getest op gevoelige huid',
      pt: 'Made in Italy · Testado em pele sensível' };
    var txt = L[(document.documentElement.lang || 'it').slice(0, 2)] || L.it;
    if (!txt) return;
    var s = document.createElement('span'); s.className = 'elx-ovl'; s.textContent = txt; s.setAttribute('aria-hidden', 'true');
    media.appendChild(s);
  })();
})();
